export default "__VITE_ASSET__CDCdrelz__"